// extracted by mini-css-extract-plugin
export default {"login":"Main_login__TTyZk","loginWrapper":"Main_loginWrapper__J93dY"};